// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Interfaces
import {DailyAvailability} from "Interfaces/ResortResultInterface";
import {RoomModal, RoomInformation} from "Interfaces/RoomModalInterface";

// Components
import MvModal from "Generic/MvModal";
import MvLoader from "Generic/MvLoader/MvLoader"

// Styles
import "./MvArrivingGuestInfoAlertModal.sass"
import moment from "moment";
import { MvPrimaryBtn } from "Generic/MvPrimaryBtn";

interface Props {
  show: boolean;
  toggle(): void;
  reservationInformation: any
  handleRedirect(): void;
};

class MvArrivingGuestInfoAlertModal extends React.Component<Props, {}> {

  render() {
    
    const { localize } = this.context;
    const {show, toggle, reservationInformation, handleRedirect} = this.props;


    return (
      <MvModal openModal={show} toggleModal={toggle}>
        {/* <MvLoader show={!this.props.fetchLoaded} > */}
          <div className="modal-container">
            <div className='modal-header'>{localize("static.content.alert-title")}</div>       
            <div className='desc-content'>
                <p className="res-info-heading">{localize("static.content.alert-body-content")}</p>
                <div className="flex">      
                  <div className="res-info-div-label">{localize("static.content.alert-body-resort-name")}:</div> <div className="res-info-div-value">{reservationInformation.resortName}</div>
                </div>
                <div className="flex">  
                  <div className="res-info-div-label">{localize("static.content.alert-body-resort-location")}:</div> <div className="res-info-div-value">{reservationInformation.resortLocation}</div>
                </div>
                <div className="flex">
                  <div className="res-info-div-label">{localize("static.content.alert-body-reservation-date")}:</div> <div className="res-info-div-value">{moment(reservationInformation.checkInDate).format('DD MMM YYYY')} - {moment(reservationInformation.checkOutDate).format('DD MMM YYYY')}</div>
                  {/* <div className="res-info-content"><div className="res-info-div-label">{localize("static.content.alert-body-resort-name")}:</div> <div className="res-info-div-value">{reservationInformation.resortName}</div></div>
                  <div className="res-info-content"><div className="res-info-div-label">{localize("static.content.alert-body-resort-location")}:</div> <div className="res-info-div-value">{reservationInformation.resortLocation}</div></div>
                  <div className="res-info-content"><div className="res-info-div-label">{localize("static.content.alert-body-reservation-date")}:</div> <div className="res-info-div-value">{moment(reservationInformation.checkInDate).format('DD MMM YYYY')} - {moment(reservationInformation.checkOutDate).format('DD MMM YYYY')}</div></div> */}
                </div>
                <div className="note" dangerouslySetInnerHTML={{__html: localize("static.content.alert-body-note")}}></div>
                <div className="btn-container">
                    <MvPrimaryBtn
                        isDisabled={false} 
                        text={"Continue"}
                        submissionInProgress={false}
                        onClick={() => handleRedirect()}
                    />
                </div>
            </div>
          </div>
        {/* </MvLoader> */}
      </MvModal>
    );
  }
};

MvArrivingGuestInfoAlertModal.contextType = LocalizationContext;
export {
  MvArrivingGuestInfoAlertModal,
};
